var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinifacebooklogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14180",
    "data-name": "Group 14180",
    transform: "translate(-1189 -3935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1189 3935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(1200.751 3943.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M4.254,4.433V3.267a2.534,2.534,0,0,1,.025-.406.783.783,0,0,1,.113-.283.459.459,0,0,1,.283-.193,2.042,2.042,0,0,1,.52-.053H6.377V0H4.487A3.1,3.1,0,0,0,2.131.767a3.2,3.2,0,0,0-.716,2.262v1.4H0V6.764H1.415v6.764H4.254V6.764h1.89l.25-2.331Z",
    fill: "#3a559f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinifacebooklogo);
export default __webpack_public_path__ + "static/media/minifacebooklogo.0d9a3267b4c58b03976dbfe64a3c5fb1.svg";
export { ForwardRef as ReactComponent };